import React from 'react';
import { connect } from 'react-redux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';

import { Actions, AppState, IPageState, store } from './../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import BackspaceIcon from '@material-ui/icons/Backspace';



import { Card, CardActions, FormControl, Grid, TextField } from '@material-ui/core';
import CONFIG from 'cfg/config';
import { KarnetLogo, KarnetService, Result } from 'api';


//import { PrefiksPl, telefonService } from 'api';
//import { sendErrorLog, stacjonarnyPrefix } from '../common/helpers';


interface DialogErrorProps extends WithStyles<typeof styles>  {
  //classes?: any,
  page: IPageState,

  open: boolean,
  number: number,
  close: (id: number) => void,
  noCloseButton?: boolean,
  karnet?: boolean,
  closeAll: () => void;
  telefon?: boolean,
  setNumber: (value: any, id: number) => void,
  id: number,
  //setNumber: () => void,
  title: string,
  placeholder: string,
  //openGalery: () => void,
  phoneMode? :boolean,
  nipMode? :boolean,
  max?: number,
  error?: string,
  oknoSms?: boolean,
  backdropClick?: boolean,
  
}

interface KlawiaturaState {
  numer: string,
  error: string,
  title: string,
  check: boolean,
  openInfo1: boolean,
  openInfo2: boolean,
}

let numberSpaces = (str: string) => {
   return str.split('').map((d, i) => (i) % 3 == 0 ? ' ' + d : d).join('').trim()
}

class DialogError extends React.Component<DialogErrorProps, KlawiaturaState> {
    stylInputaRezerwacja: React.CSSProperties = { padding: "11px 14px", textAlign: "left", fontWeight: "bold", fontSize: "1.25rem" };

  constructor(props: any) {
    super(props, {});
  }
  state = {
    numer: this.props.number === 0 ? "" : this.props.max ? this.props.number.toString().substring(0, this.props.max) : this.props.number.toString(),
    error: "",
    title: "",
    check: false,
    openInfo1: false,
    openInfo2: false,
  };

  componentDidUpdate(prevProps: DialogErrorProps) {
    if (prevProps.open !== this.props.open) {
      let n = this.props.number === 0 ? "" : this.props.max ? this.props.number.toString().substring(0, this.props.max) : this.props.number.toString()
      this.setState({numer: n, title: "", check: false, error: "", openInfo1: false, openInfo2: false})
    
      // if(this.props.phoneMode){
      //   this.phoneErrors(n)
      // }
    }
   
  }

  
 
  setNumer = (event: React.ChangeEvent<{ name?: string; value: string; }>) => {
 
    if ((event.target.value as string).toString().length <= (this.props.max || 99)) {
      this.setState({ numer: event.target.value, error: "" })
    }

    if(this.state.check){
      // if(this.props.phoneMode){
      //   this.phoneErrors(event.target.value as string)
      // }
    }
    
  
    if(event.target.value && event.target.value !== "0")
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
    else  
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(255, 255, 255)" };  
  }

  addToNumer = (n: number) => {
    if (this.state.numer.length < (this.props.max || 99)) {
      let num = this.state.numer + n.toString()
      this.setState({numer: num, error: ""})

      if(this.state.check){
        // if(this.props.phoneMode){
        //   this.phoneErrors(num)
        // }
      }
  
    }
  } 

  clear = () => {
    let num = this.state.numer
    num = num.slice(0, -1);
    this.setState({numer: num, error: ""})
  }

  clearAll = () => {
    this.setState({numer: "", error: ""})
  }

  setValue = () => {   
    if(this.props.karnet){
      this.setKarnet()
    } else if (this.props.telefon){

      // this.props.page?.karnet.telefon   ma 48
      if(this.state.numer.toString() === this.props.page?.karnet.telefon ||  "48" + this.state.numer.toString() === this.props.page?.karnet.telefon){
        let link = "https://vsc24.net/vscSmartSki/karnet/" + CONFIG.hotelId + "/" + this.props.page?.karnet.logo
        window.open(link, "_parent")
      } else {
        this.setState({error: "Niepoprawny numer telefonu"})
        this.setState({openInfo2: true})
      }
      

    }else {

      
    //if(this.state.check || this.props.oknoSms){
      this.props.setNumber(this.state.numer.toString(), this.props.id)  
      this.props.close(this.props.id)
    //} else {

      this.setState({check: true})
      // if(this.props.phoneMode){
      //   this.phoneErrors(this.state.numer, true)
      // }
    //}

    }

 }

  setKarnet = async () => {

    try {
      let logo = this.state.numer.toString()
      if(logo.length < 5){
        logo = logo.padStart(5, '0')
      }

      let res: Result<KarnetLogo> = await KarnetService.dajKarnet({parametry: {hotelId: CONFIG.hotelId, karnetLogo: logo, operatorId: "1" }})
      if(res.result.length > 0){
        store.dispatch(Actions.pageState.setKarnet(res.result[0]))
        //
        if(res.result[0].telefon === ""){
          let link = "https://vsc24.net/vscSmartSki/karnet/" + CONFIG.hotelId + "/" + logo
          window.open(link, "_parent")
        } else {
          this.props.setNumber(logo, this.props.id)  
        }
        
        //
      }else {
        store.dispatch(Actions.pageState.setKarnet(new KarnetLogo()))
        this.setState({error: "Niepoprawny numer karnetu"})
        this.setState({openInfo1: true})

      }
      
    } catch (error) {
      console.error()
    }

  }

  closeInfo1 = () => {
    this.setState({openInfo1: false})
  } 
  closeInfo2 = () => {
    this.setState({openInfo2: false})
  }
  closeAll = () => {
    this.props.closeAll()
  }

  
  // phoneErrors = async (phone: string, accept: boolean = false): Promise<string> => {
  //   const { classes } = this.props;

  //   if (phone.length < 9) {
  //     this.setState({error: "Niepoprawny numer"})
  //     return "Niepoprawny numer"
  //   }

  //   let sta = stacjonarnyPrefix(phone)
  //   if (sta !== "") {
  //     this.setState({error: "Niepoprawny numer"})
  //     return "Niepoprawny numer"
  //   }

  //   // if(this.props.page.czarnaLista.find((x: {tel: string}) => phone.includes(x.tel))){
  //   //   //czarna lista
  //   //   this.setState({error: "Niepoprawny numer telefonu"})
  //   //   return "Niepoprawny numer telefonu"
  //   // }

  //   // if(!this.poprawnyPolskiNumer(phone, 0, 2, this.props.page.prefiksyPl)){
  //   //   this.setState({error: "Niepoprawny numer telefonu"})
  //   //   return "Niepoprawny numer telefonu"
  //   // }

  //   try {
  //     let res = await telefonService.sprawdzNrTelefonu({ nrTelefonu: phone }, {})

  //     if (Number(res.result) > 0) {
  //       this.setState({error: ""})
  //       if(accept){
  //         this.props.setNumber(this.state.numer.toString())  
  //         this.props.close(true)
  //       }
  //       return ""
  //     }
  //     this.setState({error: "Niepoprawny numer"})
  //     return "Niepoprawny numer"

  //   } catch (error) {
  //     //sendErrorLog("0", "-1", 'vscSms/sms/sprawdzNrTelefonu')
  //     //await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/sprawdzNrTelefonu", 2))
  //     console.log(error);
  //   }
  //   this.setState({error: ""})
  //   if(accept){
  //     this.props.setNumber( this.state.numer.toString())  
  //     this.props.close(true)
  //   }
  //   return ""
  // }

  // poprawnyPolskiNumer = (phone: string, start: number, end: number, prefiksy: PrefiksPl[]): boolean => {
  //   let ret = false
  //   if(prefiksy.length === 0) return true
  //   prefiksy.forEach(x => {
  //     if(phone.substring(start, end) === x.prefiks) ret = true
  //   })
  //   return ret
  // }

  


  render() {
    const classes = this.props.classes;
    const wciecie: string = '   * ';

    return (
      <>
      <Dialog
        disableBackdropClick={!this.props.backdropClick}
        maxWidth="sm"
        classes={{paper: classes.paper}}
        open={this.props.open}
        onClose={() => this.props.closeAll()}
        fullWidth               
      >
        <DialogTitle disableTypography style={{paddingBottom: "12px"}}>
          <Typography gutterBottom variant="h5" component="h2" color='primary' style={{ fontSize: "1.25rem" }} >
            <b>{ this.state.title ? this.state.title : this.props.title}</b>
          </Typography>
          <hr />
        </DialogTitle>

        <DialogContent  >
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {/* <FormControl component="fieldset" variant="outlined" fullWidth margin='normal' >
                            <Typography gutterBottom variant="h5" component="span" color="primary">
                                <b>{"telefon nr"}</b>
                            </Typography> */}
                            <TextField
                                //label="telefon"
                                //disabled
                                id="zamowieniaTextField"
                                type="number"
                                
                                //type="phone"
                                autoFocus
                                //name="phone"
                                placeholder={this.props.placeholder}
                                style={{ width: "100%" }}
                                inputProps={{ style: this.stylInputaRezerwacja }}
                                InputProps={{ classes: { input: `${classes.primaryTextField}` }, }}
                                InputLabelProps={{
                                    shrink: true,
                                  }}
                                value={this.state.numer}
                                onChange={this.setNumer}
                                variant="outlined"

                                //error={this.props.error === undefined || this.props.error === "" ? false : true}
                                //helperText={this.props.error}
                                error={this.state.error === undefined || this.state.error === "" ? false : true}
                                helperText={this.state.error}
                            //error={err}
                            //helperText={err ? "Niepoprawny numer telefonu" : ""}
                            />

                        {/* </FormControl> */}
                    </Grid>


                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(1)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>1</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(2)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>2</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(3)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>3</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(4)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>4</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(5)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>5</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(6)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>6</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(7)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>7</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(8)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>8</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(9)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>9</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.clearAll()} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>C</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(0)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>0</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.clear()} variant="outlined" size="small" color="primary"
                            className={classes.button}  >
                                 <BackspaceIcon style={{ width: "1em", height: "1em" }} />
                                </Button>
                    </Grid>
                   
                </Grid>





          
        </DialogContent >
        <DialogActions >

          {!this.props.noCloseButton ?
            <Button onClick={() => this.props.close(this.props.id)} variant="outlined" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b><Trans>Back</Trans></b>
            </Button> : null}

            <Button  variant="contained" size="small" color="primary" onClick={this.setValue}
              style={{ textTransform: "none", fontSize: "0.8rem" }}
              disabled={this.props.phoneMode && (this.state.numer.length !== 9) ||
                        this.props.nipMode && (this.state.numer.length !== 0 && this.state.numer.length !== 10) ||
                        this.state.error !== ""}
            >
              <b><Trans>OK</Trans></b> 
              
            </Button>
         
         
        </DialogActions>
      </Dialog>

        <Dialog
          maxWidth="xs"
          classes={{paper: classes.paper}}
          open={this.state.openInfo1}

          disableBackdropClick={!this.props.backdropClick}
          onClose={this.closeInfo1}
          //onEscapeKeyDown={this.props.closeDialog}
          //onBackdropClick={this.props.closeDialog}
          fullWidth
        >
          <DialogTitle disableTypography >
            <Typography gutterBottom variant="h6" component="h2" color={"error"}
              className={`${classes.headline}`}><b style={{}}>{"coś poszło nie tak"}</b>
            </Typography>
            <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
          </DialogTitle>
          <DialogContent>

            <DialogContentText className={classes.dialogContentText} >
              {/* {"Nie znaleziono karnetu "} <b className={classes.primary} >{this.state.numer}</b> */}
              {"Nie mamy karnetu "} 
              <b className={classes.primary} >{this.state.numer}</b>
            </DialogContentText>
            <DialogContentText className={classes.dialogContentText} >
              {""}
            </DialogContentText>
            <DialogContentText className={`${classes.dialogContentText}`} >
              {"Naciśnij klawisz"}
            </DialogContentText>
            <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
              {wciecie}<b className={classes.primary} >{"wróć"}</b>{" aby spróbować jeszcze raz"}
            </DialogContentText>
            <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
              {wciecie}<b className={classes.primary} >{"OK"}</b>{" aby zobaczyć nasze atrakcje"}
            </DialogContentText>

          </DialogContent>
          <DialogActions>

            <Button variant="outlined" color={"primary"} size="small" 
              onClick={this.closeInfo1}  style={{ textTransform: "none", fontSize: "0.8rem" }}>
              <b>wróć</b>
            </Button>

            <Button variant="contained" color="primary" size="small" 
              onClick={this.closeAll}  style={{ textTransform: "none", fontSize: "0.8rem" }}>
              <b>OK</b>
            </Button> 


          </DialogActions>
        </Dialog>

        <Dialog
          maxWidth="xs"
          classes={{paper: classes.paper}}
          open={this.state.openInfo2}

          disableBackdropClick={!this.props.backdropClick}
          onClose={this.closeInfo2}
          //onEscapeKeyDown={this.props.closeDialog}
          //onBackdropClick={this.props.closeDialog}
          fullWidth
        >
          <DialogTitle disableTypography >
            <Typography gutterBottom variant="h6" component="h2" color={"error"}
              className={`${classes.headline}`}><b style={{}}>{"coś poszło nie tak"}</b>
            </Typography>
            <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
          </DialogTitle>
          <DialogContent>

            <DialogContentText className={classes.dialogContentText} >
              {/* {"Wpisano błędny numer telefonu"} */}
              {"Nie mamy pary karnet/telefon "}
              <b className={classes.primary} >{this.props.page.karnet.logo}{"/"}{this.state.numer} </b>
            </DialogContentText>
            <DialogContentText className={classes.dialogContentText} >
              {""}
            </DialogContentText>
            <DialogContentText className={`${classes.dialogContentText}`} >
              {"Naciśnij klawisz"}
            </DialogContentText>
            <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
              {wciecie}<b className={classes.primary} >{"wróć"}</b>{" aby spróbować jeszcze raz"}
            </DialogContentText>
            <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
              {wciecie}<b className={classes.primary} >{"OK"}</b>{" aby zobaczyć nasze atrakcje"}
            </DialogContentText>

          </DialogContent>
          <DialogActions>

            <Button variant="outlined" color={"primary"} size="small" 
              onClick={this.closeInfo2}  style={{ textTransform: "none", fontSize: "0.8rem" }}>
              <b>wróć</b>
            </Button>

            <Button variant="contained" color="primary" size="small" 
              onClick={this.closeAll}  style={{ textTransform: "none", fontSize: "0.8rem" }}>
              <b>OK</b> 
            </Button> 


          </DialogActions>
        </Dialog>
      </>

    );
  }
}

const styles = (theme: Theme) => ({
  paper: {
    maxWidth: "350px"
  },
  primary: {
    color: theme.palette.primary.main
  },
  actionButtons: {
    textTransform: "lowercase" as "lowercase",
    fontSize: '0.8rem'
  },
  button: {
    width: "100%",
    height: "45px",
    textTransform: "none" as "none", 
    fontSize: "1.25rem"
  },
  primaryTextField: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
    textAlign: 'left' as 'left',
    fontSize: "1rem"
},

headline: {
  lineHeight: "20px",
},
dialogContentText: {
  //color: theme.palette.text.secondary,
  //color: theme.palette.primary.main,
  //whiteSpace: "pre" as "pre",
  minHeight: "12px",
  marginBottom: '12px'
},

paddingLeft: {
  paddingLeft: "10px"
}

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogError));